export const CHECKER_TYPES = {
  // Минимальная длина строки
  lengthMin: 'lengthMin',
  // Максимальная длина строки
  lengthMax: 'lengthMax',
  // Строка содержит хотя бы один латинский символ в нижнем регистре
  lowerCaseLatinSymbol: 'lowerCaseLatinSymbol',
  // Строка содержит хотя бы один латинский символ в верхнем регистре
  upperCaseLatinSymbol: 'upperCaseLatinSymbol',
  // Строка содержит хотя бы одну цифру
  digit: 'digit',
  // Строка содержит только цифры
  digitsAll: 'digitsAll',
  // Строка содержит хотя бы один специальный символ
  specialSymbol: 'specialSymbol',
  // Минимальное значение для числа
  minValue: 'minValue',
  // Максимальное значение для числа
  maxValue: 'maxValue',
  // Адрес электронной почты
  email: 'email',
  // Проверка на вещественное число
  float: 'float',
  // Проверка на целое число
  int: 'int',
  // Проверка на максимальное количество пунктов в поле.
  maxCount: 'maxCount',
  // Проверка на минимальное количество пунктов в поле.
  minCount: 'minCount'
}
